/**
 * Unwrap the default export of a CommonJS module. In an ESM package Rolldown resolves
 * `import X from 'cjs-lib'` to the whole `module.exports`, so Babel-compiled libraries yield
 * `{ __esModule: true, default: X }` instead of `X`. No-op for ESM and plain `module.exports = X`.
 * See https://rolldown.rs/in-depth/bundling-cjs#ambiguous-default-import-from-cjs-modules
 */
export const cjsDefault = <T>(mod: T): T => {
  if (typeof mod === 'object' && mod !== null && '__esModule' in mod && 'default' in mod) {
    return (mod as { default: unknown }).default as T
  }
  return mod
}
